import { ON_SERVER } from './context';

const navigate = (url: string): void => {
  if (ON_SERVER) return;

  window.location.href = url;
};

// eslint-disable-next-line import/prefer-default-export
export { navigate };
